import React from 'react'
import classnames from 'classnames'

interface AnchorButtonProps {
	href: string
	children: React.ReactNode
	className?: string
	newTab?: boolean
}

export default function AnchorButton({ href, children, className = '', newTab = true }: AnchorButtonProps) {
	return (
		<a
			href={href}
			target={newTab ? '_blank' : undefined}
			rel={newTab ? 'noopener noreferrer' : undefined}
			className={classnames(
				'rounded-md bg-indigo-600 px-5 py-3 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600',
				className,
			)}
		>
			{children}
		</a>
	)
}
